import { css } from '@firebolt-dev/css'
import { useEffect, useState } from 'react'

import { items } from '../../shared/Items'

const DURATION = 2500

let nextId = 0

export function Toasts({ world }) {
  const [toasts, setToasts] = useState([])

  useEffect(() => {
    function onItemsGained(gained) {
      const now = Date.now()
      const merged = {}
      for (const slot of gained) {
        merged[slot.id] = (merged[slot.id] || 0) + slot.qty
      }
      const newToasts = Object.entries(merged)
        .map(([id, qty]) => {
          const item = items[id]
          if (!item) return null
          return { key: nextId++, id, qty, icon: item.icon, name: item.name || id, addedAt: now }
        })
        .filter(Boolean)
      if (!newToasts.length) return
      setToasts(prev => [...prev, ...newToasts])
      setTimeout(() => {
        setToasts(prev => prev.filter(t => !newToasts.some(n => n.key === t.key)))
      }, DURATION)
    }
    world.on('itemsGained', onItemsGained)
    return () => world.off('itemsGained', onItemsGained)
  }, [])

  if (!toasts.length) return null

  return (
    <div
      css={css`
        position: absolute;
        left: calc(env(safe-area-inset-left) + 15px);
        top: 50%;
        transform: translateY(-50%);
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 2px;
        pointer-events: none;
      `}
    >
      {toasts.map(toast => (
        <Toast key={toast.key} toast={toast} />
      ))}
    </div>
  )
}

function Toast({ toast }) {
  return (
    <div
      css={css`
        display: flex;
        align-items: center;
        background: rgba(0, 0, 0, 0.6);
        border-radius: 8px;
        padding: 2px 10px 2px 2px;

        animation:
          item-toast-in 0.2s ease-out,
          item-toast-out 0.3s ease-in ${DURATION - 300}ms forwards;
        @keyframes item-toast-in {
          from {
            opacity: 0;
            transform: translateX(-16px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }
        @keyframes item-toast-out {
          from {
            opacity: 1;
          }
          to {
            opacity: 0;
            transform: translateX(-16px);
          }
        }

        .toast-text {
          font-size: 16px;
          line-height: 0;
          color: white;
          white-space: nowrap;
        }

        .toast-icon {
          width: 30px;
          height: 30px;
          background: url(${toast.icon});
          background-size: cover;
          image-rendering: pixelated;
          flex-shrink: 0;
          margin: 0 5px 0 0;
        }

        /* @media all and (max-width: 860px) {
          .toast-icon {
            width: 30px;
            height: 30px;
          }
        } */
      `}
    >
      <div className='toast-icon' />
      <span className='toast-text'>{toast.qty > 1 ? `${toast.name} x${toast.qty} ` : toast.name}</span>
    </div>
  )
}
